import React, { useEffect, useRef, useState } from "react";
import "./BusinessBenefits.css";

/* ============================================================
   NOTE: icons ke liye Bootstrap Icons already project me chahiye
   (aapke code me `bi bi-gear` use ho raha hai, to ye pehle se hoga).
   Agar nahi hai to public/index.html me ye line add karo:
   <link rel="stylesheet"
     href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />
   ============================================================ */

/* ============================================================
   CONTENT  (yahin se edit karo)
   ============================================================ */
const HEAD = {
  title: "Business Benefits",
  subtitle:
    "Discover how GPMS delivers value through intelligent vehicle monitoring and parking management.",
};

const BENEFITS = [
  { icon: "bi-gear", title: "Faster vehicle verification" },
  { icon: "bi-piggy-bank", title: "Stronger revenue assurance" },
  { icon: "bi-shield-check", title: "Better security oversight" },
  { icon: "bi-car-front", title: "More efficient airport parking operations" },
];

/* scroll-in hook: section screen par aate hi cards "visible" ho jate hain */
const useInView = (threshold = 0.2) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (!("IntersectionObserver" in window)) {
      setSeen(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, seen];
};

/* props: title, subtitle, items=[{icon,title,text?}], showText (true => card me text bhi dikhega) */
const BusinessBenefits = ({
  title = HEAD.title,
  subtitle = HEAD.subtitle,
  items = BENEFITS,
  showText = false,
}) => {
  const [ref, seen] = useInView();

  return (
    <div className="benefits-wrapper1" ref={ref}>
      <div className="benefits-header1">
        <h2 className="text-center benefi">{title}</h2>
        <p className="aps-sub-benefits">{subtitle}</p>
      </div>

      <div className={`bento-grid bb-n${Math.min(items.length, 6)}`}>
        {items.map((b, i) => (
          <div
            key={b.title}
            className={`feature-card ${seen ? "visible" : ""}`}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="icon-circle">
              <i className={`bi ${b.icon}`} aria-hidden="true"></i>
            </div>
            <h3 className="rajdhani-font">{b.title}</h3>
            {showText && b.text && <p className="bb-text">{b.text}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessBenefits;